<template>
    <info-popover :disabled="!enableTooltip" :content="tooltip" placement="right" class="d-inline">
        <span class="badge badge-highlight badge-tiny align-middle">
            <img src="/static/general/img/icons/shines.svg" height="11" class="align-middle" />
            <span class="align-middle" style="margin-left: 2px">{{ label }}</span>
        </span>
    </info-popover>
</template>

<script>
import InfoPopover from "@/components/InfoPopover"

export default {
    name: "AiBadge",
    components: {
        InfoPopover,
    },
    props: {
        enableTooltip: {
            type: Boolean,
            required: false,
            default: true,
        },
        label: {
            type: String,
            required: false,
            default() {
                return "AI"
            },
        },
        tooltip: {
            type: String,
            required: false,
            default() {
                return "AI-powered functions"
            },
        },
    },
}
</script>

<style>
</style>